<div class="top-bar" data-theme-key="--bg-elevated">
  <div class="top-left">
    @if (viewMode === responsiveMode.horizontal) {
      <div class="top-copy top-copy-desktop">
        @if (hasLogo) {
          <div class="hotel-logo-wrap hotel-logo-wrap-desktop" data-theme-key="--bg-logo" [style.aspect-ratio]="logoAspectRatio">
            <img #desktopLogoImage class="hotel-logo" [src]="logoUrl ?? ''" alt="Property logo" (load)="onLogoLoad()" (error)="onLogoError()" />
          </div>
        }

        <div class="top-text top-text-div" data-theme-key="--text-main">
          <p>
            Thank you for choosing {{ sharedService.propertyName | titlecase }}!
          </p>
          <p data-theme-key="--text-muted">
            You're booked in a {{ sharedService.baseRoomCategoryName == null ? '' : sharedService.baseRoomCategoryName | titlecase}} -
            Arriving {{sharedService.arrivalDate == null ? '' : sharedService.arrivalDate | date:'fullDate'}} - Confirmation: {{sharedService.confirmationNumber == null ? '' : sharedService.confirmationNumber}}
            <br>
            Upgrade now - no payment today. Limited availability.
          </p>
        </div>
      </div>

      <div class="top-actions">
        <button type="button" class="icon-circle-btn" (click)="refresh()" aria-label="Refresh">
          <span class="material-icons">refresh</span>
        </button>
        <div class="theme-toggle" data-theme-key="--chip-bg" id="themeToggle" role="group" aria-label="Theme toggle">
          <button
            data-theme-key="--seg-active-bg"
            type="button"
            class="theme-toggle-btn"
            id="btnLight"
            [class.active]="!themeService.isDarkMode()"
            aria-label="Light mode"
            (click)="onThemeModeSelected(false)">
            <span class="material-icons">light_mode</span>
          </button>

          <button
            data-theme-key="--seg-active-bg"
            type="button"
            class="theme-toggle-btn"
            id="btnDark"
            [class.active]="themeService.isDarkMode()"
            aria-label="Dark mode"
            (click)="onThemeModeSelected(true)">
            <span class="material-icons">dark_mode</span>
          </button>
        </div>
      </div>
    }
  </div>

  @if (viewMode === responsiveMode.vertical) {
      <div class="top-copy top-copy-handset">
        <div class="top-row-handset">
          @if (hasLogo) {
            <div class="hotel-logo-wrap hotel-logo-wrap-handset" data-theme-key="--bg-logo" [style.aspect-ratio]="logoAspectRatio">
              <img #handsetLogoImage  class="hotel-logo" [src]="logoUrl ?? ''" alt="Property logo" (load)="onLogoLoad()" (error)="onLogoError()" />
            </div>
          }

          <div class="top-actions top-actions-handset">
            <button type="button" class="icon-circle-btn" data-theme-key="--seg-active-bg" (click)="refresh()" aria-label="Refresh">
              <span class="material-icons">refresh</span>
            </button>
            <div class="theme-toggle" data-theme-key="--chip-bg" id="themeToggle" role="group" aria-label="Theme toggle">
              <button
                type="button"
                class="theme-toggle-btn"
                id="btnLight"
                [class.active]="!themeService.isDarkMode()"
                aria-label="Light mode"
                (click)="onThemeModeSelected(false)">
                <span class="material-icons">light_mode</span>
              </button>

              <button
                type="button"
                class="theme-toggle-btn"
                id="btnDark"
                [class.active]="themeService.isDarkMode()"
                aria-label="Dark mode"
                (click)="onThemeModeSelected(true)">
                <span class="material-icons">dark_mode</span>
              </button>
            </div>
          </div>
        </div>

        <div class="top-text" data-theme-key="--text-main">
          <p>
            Thank you for choosing {{ sharedService.propertyName | titlecase }}!
          </p>
          <p data-theme-key="--text-muted">
            You're booked in a {{ sharedService.baseRoomCategoryName == null ? '' : sharedService.baseRoomCategoryName | titlecase}} -
            Arriving {{sharedService.arrivalDate == null ? '' : sharedService.arrivalDate | date:'fullDate'}} - Confirmation: {{sharedService.confirmationNumber == null ? '' : sharedService.confirmationNumber}}
            Upgrade now - no payment today. Limited availability.
          </p>
        </div>
      </div>

  }


</div>
